export const VARIANTS_ZONE_KEY = 'variant_zone'
export const BACK_FROM_VARIANT_EDITOR = 'arc.backFromVariantEditor'
export const STORY_ID = 'arc.variant.storyId'
export const NEW_EDITOR_EXP = 'arc.newEditorExp'
export const DELETED_FROM_NEW_EDITOR = 'arc.storyDeletedFromNewEditor'
export const STORY_DELETED_NAME = 'arc.storyDeletedName'

export const DEFAULT_SNACKBAR_TIMEOUT = 3000

// evidently flags
export enum EVIDENTLY_FLAG {
  CONDITIONAL_CONTENT = 'conditional-content-feature',
  AI_FEATURES = 'ai-features',
  ANNOTATIONS = 'annotations-feature',
  RTL_CONFIG = 'rtl-config-feature',
  SHOW_SECTION_NAME = 'show-section-name-feature',
  DRAFT_API_STATEFUL = 'draft-api-stateful-feature',
  ARC_SPELLCHECKER = 'arc-spellcheck-feature',
  FB_INSTA_OEMBED_V8 = 'fb-insta-oembed-v8-feature',
  V2_OPEN_BETA = 'v2-open-beta',
}
